module.exports = __webpack_public_path__ + "img/poer2_bg.9f31abf5.jpg";